/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" cx="12" cy="12" r="12" _fill="#8300BF"/><path pid="1" d="M10 7v10H8V7h2zm6 0v10h-2V7h2z" _fill="#FFF"/></g>'
  }
})
